import React, {Fragment} from 'react';
import {ArrayUtils} from "../../../Utils/ArrayUtils";
import {service as FileUploadService} from "../../../Services/FileUploadService";
import autobind from 'autobind-decorator';
import clipboard from "clipboard-polyfill/dist/clipboard-polyfill.promise"
import {
    BaseTableColumn
} from "../Tables/BaseTableColumn";
import {    
    Glyphicon
} from "../../Common/GlyphIcon";
import {
    StreamBankEditableCheckerEnhance
} from "../Enhancements/StreamBankEditableCheckerEnhance";
import {
    FileEditorEnhance
} from "../Files/FileEditorEnhance";
import {
    StreamBankErrorDispatchEnhance
} from "../Enhancements/StreamBankErrorDispatchEnhance";


@StreamBankEditableCheckerEnhance
@StreamBankErrorDispatchEnhance
@FileEditorEnhance
export class ActionTableColumn extends BaseTableColumn {
    @autobind
    reloadData() {
        const { ReloadData } = this.props?.CustomData || {};

        ReloadData?.();
    }

    @autobind
    downloadFile() {
        const { rowData } = this.props;
        if(!rowData) return;

        FileUploadService.DownloadFile(rowData.fileName, rowData.fileUploadId);
    }

    @autobind
    shareFile() {
        const { rowData, ErrorDispatch } = this.props;
        if(!rowData) return;

        const link = FileUploadService.GetFileDownloadLink(rowData);
        ErrorDispatch.ShowAlert(this._renderShareLink(rowData, link), "Share " + rowData.name);
    }

    @autobind
    _copyLinkClickHandler(event) {
        const { rowData, ErrorDispatch } = this.props;
        const link = FileUploadService.GetFileDownloadLink(rowData);
        clipboard.writeText(link)
            .then(_ => ErrorDispatch.ShowAlert(this._renderShareLink(rowData, link, true), "Share " + rowData.name))
            .catch(_ => ErrorDispatch.ShowAlert(this._renderShareLink(rowData, link, false), "Share " + rowData.name));
        event.preventDefault();
        return false;
    }

    @autobind
    _renderShareLink(fileUploadObject, link, wasCopied) {
        let contextNodes = fileUploadObject?.FileUploadContextNodes?.map((x) => x.ContextNode);

        let permissionsDescription = <span>Users must log into StreamBank to access this link.</span>
        if(contextNodes) {
            // remove duplicates first
            contextNodes = ArrayUtils.uniqueByKey(contextNodes, 'contextNodeId')

            // then convert them to links
            let contextNodesLinks = contextNodes
                .map((contextNode) => <a href={contextNode.link}>{contextNode.title}</a>);

            // and join them in a human readable form
            const contextNodesDescription = ArrayUtils.arrayJoin(contextNodesLinks, ', ', ' or ');

            permissionsDescription = <span>
                Users must log into StreamBank to access this link, and they must have permission to view {contextNodesDescription}.
            </span>
        }

        let subtext = "Click the link to copy it to your clipboard.";
        if(wasCopied === true) {
            subtext = "Link has been copied!";
        } else if(wasCopied === false) {
            subtext = "Your browser does not support this feature. Please copy the link manually.";
        }

        return <Fragment>
            <p className="sb-shareable-link-description">The below link can be shared with other StreamBank users. {permissionsDescription}</p>
            <div className="sb-shareable-link"><a href={link} onClick={this._copyLinkClickHandler}>{link}</a></div>
            <p className="sb-shareable-link-subtext">{subtext}</p>
        </Fragment>;
    }

    @autobind
    _render() {
        const { FileEdit, Value, rowData, EditableChecker } = this.props;
        if(!rowData || !Value) return <span>N/A</span>;

        return <div className="actions">
            {
                EditableChecker.CanEditFileUpload(rowData) ?
                    <a className="link-primary" onClick={_ => FileEdit.DisplayEditOverlay(rowData)} title="File Details">
                        <Glyphicon glyph="pencil" />
                    </a>:
                    null
            }
            <a className="link-primary" onClick={this.downloadFile} title="Download">
                <Glyphicon glyph="cloud-download" />
            </a>

            <a className="link-primary" onClick={this.shareFile} title="Copy Link to Share">
                <Glyphicon glyph="share" />
            </a>
        </div>;
    }
}
